import React, { useState } from "react";
import { Button, Dropdown, message } from "antd";
import {
  DownloadOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileWordOutlined,
} from "@ant-design/icons";
import useAuth from "hooks/useAuth";
import { isDpatDistrictRestrictedViewer } from "config/contextModules";

const DpatExportButtons = ({
  label = "Download",
  onPdf,
  onWord,
  onExcel,
  onCsv,
  disabled = false,
}) => {
  const { user } = useAuth();
  const pdfOnly = isDpatDistrictRestrictedViewer(user);
  const [busy, setBusy] = useState(false);

  const run = async (handler, kind) => {
    if (!handler || busy || disabled) return;
    setBusy(true);
    try {
      await handler();
    } catch (error) {
      console.error(`DPAT ${kind} export failed:`, error);
      message.error(`Could not download ${kind}. Please try again.`);
    } finally {
      setBusy(false);
    }
  };

  const items = [
    onPdf && {
      key: "pdf",
      icon: <FilePdfOutlined />,
      label: "PDF",
      onClick: () => run(onPdf, "PDF"),
    },
    !pdfOnly && onWord && {
      key: "word",
      icon: <FileWordOutlined />,
      label: "Word",
      onClick: () => run(onWord, "Word"),
    },
    !pdfOnly && onExcel && {
      key: "excel",
      icon: <FileExcelOutlined />,
      label: "Excel",
      onClick: () => run(onExcel, "Excel"),
    },
    !pdfOnly && onCsv && {
      key: "csv",
      icon: <FileTextOutlined />,
      label: "CSV",
      onClick: () => run(onCsv, "CSV"),
    },
  ].filter(Boolean);

  return (
    <div data-export-hide className="flex items-center">
      <Dropdown menu={{ items }} trigger={["click"]} disabled={disabled || busy || items.length === 0}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          loading={busy}
          disabled={disabled}
          style={{
            backgroundColor: "#16325a",
            borderColor: "#16325a",
            boxShadow: "0 8px 18px rgba(22, 50, 90, 0.18)",
            height: 36,
            paddingInline: 14,
            fontWeight: 600,
          }}
        >
          {label}
          <DownOutlined style={{ fontSize: 10, marginLeft: 8 }} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default DpatExportButtons;
